// Unpublished Work © 2020-2026 Deere & Company.

import t from 'tcomb';
import {Locale} from './locale';
import {AdminActivities} from './admin-activities';

export const User = t.struct({
    country: t.String,
    dbsSourceSystemId: t.String,
    featureFlags: t.dict(t.String, t.Boolean),
    locale: t.String,
    r2ProfileUser: t.Boolean,
    impersonateUserId: t.String,
    isCSC2User: t.Boolean,
    adminActivities: AdminActivities,
    loggedInUserId: t.String,
    isUserRedirectedToSearch: t.Boolean,
    isUserRedirectedToProfile: t.Boolean,
    r2CRMUser: t.Boolean,
    isDealer: t.Boolean,
    r2CRMSourceSystemId: t.String,
    isBranch29User: t.Boolean,
    dbsLinkedCount: t.Integer
}, {
    defaultProps: {
        country: '',
        dbsSourceSystemId: '',
        featureFlags: {},
        locale: Locale.meta.map['en-US'],
        r2ProfileUser: true,
        impersonateUserId: '',
        isCSC2User: false,
        adminActivities: {},
        loggedInUserId: '',
        isUserRedirectedToSearch: false,
        isUserRedirectedToProfile: false,
        r2CRMUser: false,
        isDealer: false,
        r2CRMSourceSystemId: '',
        isBranch29User: false,
        dbsLinkedCount: 0
    },
    name: 'User',
    strict: true
});
